import { Controller } from "@hotwired/stimulus";

/** The slider that picks a playing ability, with the matching description beside it. */
export default class extends Controller<HTMLElement> {
  static override targets = [
    "input",
    "option",
    "outputDescription",
    "outputValue",
  ];

  declare readonly inputTarget: HTMLInputElement;
  declare readonly optionTargets: HTMLOptionElement[];
  declare readonly outputDescriptionTarget: HTMLElement;
  declare readonly outputValueTarget: HTMLElement;

  onChange(): void {
    const value = parseFloat(this.inputTarget.value).toFixed(1);
    const option = this.optionTargets.find((it) => it.value === value);

    this.outputDescriptionTarget.textContent =
      option?.dataset.playingAbilityDescription ?? "";
    this.outputValueTarget.textContent = value;
  }
}
